import { useMemo } from 'react';

export const useDocumentContent = (page: any, reference: any) => {
  const documentContent = useMemo(() => {
    return reference && page?.getContent(reference);
  }, [page, reference]);

  const documentData = useMemo(() => (documentContent?.getData() as any) || {}, [documentContent]);

  return [documentData, documentContent];
};
